<template>
    <div class="moat-table-custom-cell-checkbox display-flex align-items-center h-100">
        <font-awesome-icon
            icon="fas fa-circle-minus"
            class="text-secondary d-inline cursor-pointer"
            size="xl"
            @click="onSelectAction('remove')"
        />
        <div
            v-if="params.allowNewTab"
            class="new-tab-icon"
            style="cursor: pointer"
            v-tooltip="{ content: 'Open company in a new tab' }"
        >
            <a :href="entityRouteLink(props.params.data.aonEntityPk)" target="_blank">
                <font-awesome-icon
                    class="text-primary mx-sm"
                    icon="fas fa-arrow-up-right-from-square"
                />
            </a>
        </div>
        <p class="small text-truncate">{{ params.value }}</p>
    </div>
</template>

<script setup>
import { reactive, inject, onBeforeMount } from 'vue'
import { useRouter } from 'vue-router'
import { entityRouteLink } from '../../router/utils'
const props = defineProps({
    params: {
        type: Object,
        required: true,
    },
})

const state = reactive({
    cellLabel: '',
    context: {},
})

const eventBus = inject('eventBus')
const router = useRouter()

onBeforeMount(() => {
    state.cellLabel = props.params.value
})

const onSelectAction = (actionType) => {
    if (actionType === 'remove') {
        if (props.params.selectAction) {
            props.params.selectAction(props.params)
        }
    }

    eventBus.emit('remove-selection', props.params)
}
</script>
